import React, { Component } from 'react';
import logo from '../img/logo.png';
import '../styles/styles.css';

import firebase from '../firebase.js';

export default class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            error: ''
        }
    }
    componentDidMount(){
        let app = this;
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                app.props.history.push('/dashboard')
            }
        });
    }
    loginSubmit(e) {
        this.setState({
            error: ''
        });
        e.preventDefault();
        var currentApp = this;
        firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password).catch(function(error) {
            // Handle Errors here.
            console.log(error.code);

            console.log(error.message);
        });
        firebase.auth().onAuthStateChanged(function(user) {
            var database = firebase.database();
            if (user) {
                database.ref('/Hotels/accounts/Hotel'+user.uid).once('value').then(function(snapshot) {
                    var hotel = snapshot;
                    if(hotel){
                        currentApp.props.history.push('/dashboard');
                    }else{
                        currentApp.setState({
                            error: 'This user is not associated with an administrative role.'
                        })
                    }
                })
            } else {
                currentApp.setState({
                    error: 'Username or password incorrect.'
                })
            }
        });
    }

    emailChange(e) {
        this.setState({
            email: e.target.value
        })
    }
    passwordChange(e) {
        this.setState({
            password: e.target.value
        })
    }

    render() {
        return(
            <div className="login-body">
                <div className="logo-container">
                    <img alt="Fácil Logo" src={logo} />
                </div>
                <h3>Dashboard Login</h3>
                <form className="login-form" onSubmit={this.loginSubmit.bind(this)}>
                    <div className="error-text">{this.state.error}</div>
                    <input className="text-input" value={this.state.email} type="text" onChange= {this.emailChange.bind(this)} placeholder="Email"/>
                    <input className="text-input" value={this.state.password} type="password" onChange= {this.passwordChange.bind(this)} placeholder="Password"/>
                    <input className="submit-input" type="submit" value="Login"/>

                    <div className="forgot-pass" >Forgot Password?</div>
                </form>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Login.js